import Draggabilly from 'draggabilly'

const directiveDragg = {}

directiveDragg.install = function (Vue) {
  Vue.directive('dragg', {
    bind: function (elem, binding, vnode) {
      var options = binding.value || {}
      var draggie = new Draggabilly(elem, options)
      var directives = vnode.data.directives

      for (var i in directives) {
        var dir = directives[i]

        if (dir.name === 'dragg-on') {
          draggie.on(dir.arg, dir.value)
        } else if (dir.name === 'dragg-once') {
          draggie.on(dir.arg, dir.value)
        }
      }

      vnode.dragg = draggie
    },

    unbind: function (elem, binding, vnode, oldVnode) {
      // TODO: UN research sa vedem exact ce se intampla aici!
      if (oldVnode.dragg) {
        oldVnode.dragg.destroy()
      }
    },
  })

  Vue.directive('dragg-on', {
    // eslint-disable-next-line no-unused-vars
    bind(elem, binding, vnode, oldVnode) {
      // No need to do anything
    },
  })

  Vue.directive('dragg-once', {
    // eslint-disable-next-line no-unused-vars
    bind(elem, binding, vnode, oldVnode) {
      // No need to do anything
    },
  })
}

export default directiveDragg
